/* tslint:disable:no-console */

import hyperlink from './hyperlink'
import handlebars from './handlebars'
import wait from './wait'

export function warn (msg: string, err?: Error): void {
  if (typeof console !== 'undefined') {
    console.warn('[Tablet] ' + msg)
    if (err) {
      console.warn(err.stack)
    }
  }
}

export function error (msg: string, err?: Error): void {
  if (typeof console !== 'undefined') {
    console.error('[Tablet] ' + msg)
    if (err) {
      console.error(err.stack)
    }
  }
}

export {
  hyperlink,
  handlebars,
  wait
}
